/* eslint-disable import/prefer-default-export */
import type { Locale } from 'date-fns';
import enLocale from 'date-fns/locale/en-US';
import esLocale from 'date-fns/locale/es';
import zhLocale from 'date-fns/locale/zh-CN';
import frLocale from 'date-fns/locale/fr';
import viLocale from 'date-fns/locale/vi';
import { useTranslation } from 'react-i18next';
import { SupportedLanguageCodes } from '../Config/SupportedLanguageCodes';

/**
 * Returns the date-fns locale for the current language detected/set by the i18next library.
 * These locales here should match the settings in the i18next files in `src/Core/i18n`.
 * If there's a mismatch, this hook will return `en-US` as the default locale.
 *
 * @returns The date-fns locale for the current language.
 */
export const useDateFnsLocale = (): Locale => {
    const { i18n } = useTranslation();
    const locale = i18n.language;

    switch (locale) {
        case SupportedLanguageCodes.English:
            return enLocale;
        case SupportedLanguageCodes.Spanish:
            return esLocale;
        case SupportedLanguageCodes.Chinese:
            return zhLocale;
        case SupportedLanguageCodes.French:
            return frLocale;
        case SupportedLanguageCodes.Vietnamese:
            return viLocale;
        default:
            return enLocale;
    }
};
